/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { ISelfUser } from "./auth.interface";

export interface IUser {
  login?: boolean;
  token?: string;
  selfUser: ISelfUser;
}
const selfUserInitialState = {
  id: "",
  contactNumber: "",
  name: "string",
  isActive: false,
  email: "",
  profileImage: "",
  userType: {
    id: 0,
    key: ""
  },
  roles: []
};
const initialState: IUser = { login: false, token: "", selfUser: selfUserInitialState };

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    Authenticate: (state, payload) => {
      state.login = true;
      state.token = payload.payload.token;
    },
    SelfUser: (state, payload) => {
      state.login = true;
      state.selfUser = payload.payload;
    },
    Logout: state => {
      state.login = false;
      state.token = "";
      state.selfUser = selfUserInitialState;
    }
  }
});

export const { Authenticate, Logout, SelfUser } = userSlice.actions;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUserDetails = (state: any) => state.user.selfUser;

export default userSlice.reducer;
